<template>
  <organism-workload />
</template>

<script>
import OrganismWorkload from "@/components/organisms/portal/internal/workload/OrganismWorkload.vue"

export default {
  name: "Workload",
  components: { OrganismWorkload },
}
</script>
